var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"label"},[_vm._v(" Imported: "+_vm._s(_vm.percentage)+" %; "+_vm._s(_vm.total)+" / "+_vm._s(_vm.current)+" ")]),_c('div',{staticClass:"stripe-background"},[_c('div',{staticClass:"stripe-1",style:({
        width: `${_vm.percentage}%`,
        borderTopRightRadius: `${(_vm.percentage < 100) ? '0px' : '5px' }`,
        borderBottomRightRadius: `${(_vm.percentage < 100) ? '0px' : '5px' }`
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }